import * as React from "react";
import { useAppSelector } from "../../../store/hooks";
import { store } from "../../../store";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface Props<T> {
  validationFn: (values: T) => Promise<boolean | null>;
}
export const CpFormValidator = <T extends any>({ validationFn }: Props<T>): React.ReactElement => {
  const { id } = useCpFormContext();
  const onBlurCounter: any = useAppSelector((state) => state.form.instances[id].meta.onBlurCounter);

  React.useEffect(() => {
    validateForm();
  }, [onBlurCounter]);

  async function validateForm() {
    const values = store.getState().form.instances[id].values;
    await validationFn(values);
  }

  return <></>;
};
